module.exports = __webpack_public_path__ + "img/icon_linkpfeil-blau_rechts.7be7ece0.svg";